import { Chip } from "@mui/material";
import { AtTagNumberProps, AtTagNumberVariant } from "../at-tag.types";

export const TagNumber = ({ label, variant }: AtTagNumberProps) => {
  const { color, backgroundColor, borderColor } = getColorClasses(variant);

  return (
    <Chip
      label={label}
      className={`!text-xs !font-semibold ${backgroundColor} ${color} !border-solid !border ${borderColor}`}
    />
  );
};

const getColorClasses = (variant: AtTagNumberVariant) => {
  switch (variant) {
    case AtTagNumberVariant.ORDER:
      return {
        color: "!text-orange-700",
        backgroundColor: "!bg-orange-50",
        borderColor: "!border-orange-300",
      };
    case AtTagNumberVariant.FOLIO:
      return {
        color: "!text-info-700",
        backgroundColor: "!bg-info-50",
        borderColor: "!border-info-300",
      };
    case AtTagNumberVariant.EMPLOYEE_NUMBER:
      return {
        color: "!text-surface-400",
        backgroundColor: "!bg-surface-50",
        borderColor: "!border-surface-200",
      };
  }
};
